export * from './list-layout.component';



// WEBPACK FOOTER //
// ./src/app/components/list-layout/index.ts